import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IMsalContext } from "@azure/msal-react";
import { StatusState } from "../Model";
import { RootState } from "..";
import { getStatus } from "../../Api";

const initialState: StatusState = {
  status: null,
  isLoaded: false
}

export const WikiSlice = createSlice({
  name: 'wiki',
  initialState: initialState,
  reducers: {
    setStatus: (state, action) => {
      if (action.payload) {
        state.status = action.payload;
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWikis.fulfilled, (state, action) => {
        state.isLoaded = true;
        state.status = action.payload;
      })
  }
})
export const getWikis = createAsyncThunk(
  'wiki/getWikis',
  async (context: IMsalContext) => {
    return await getStatus(context);
  }
);
export const selectSelectedWikiName = (state: RootState) => state.wiki.selectedWikiName;
export const selectSelectedWiki = (state: RootState) => state.wiki.selectedWiki;
export const selectWikis = (state: RootState) => state.wiki.wikis;
export const selectIsLoaded = (state: RootState) => state.wiki.isLoaded;
export const { setStatus } = WikiSlice.actions;
export default WikiSlice.reducer;